<template>
  <div
    ref="turtor"
    class="report_wrap"
  >
    <div class="repost_mobile_shiying">
      <div class="report_img">
        <div class="img_tit">内容中心</div>
      </div>
      <div class="report_options">
        <el-row
          class="option"
          justify="space-between"
          type="flex"
        >
          <el-col
            v-for="(item, index) in optionsList"
            :key="index"
            :span="8"
            :xs="8"
            :class="{ 'option_item--active': optionActive === index }"
            class="option_item"
            @click.native="changeOptionIndex(index)"
          >
            <div class="item_top">
              <img
                :src="item.icon"
                alt=""
              />
            </div>
            <div
              :class="optionActive === index ? 'active' : ''"
              class="item_bottom"
            >
              {{ item.txt }}
            </div>
          </el-col>
        </el-row>
      </div>
      <div
        v-show="optionActive === 0"
        class="report_avtive_wrap"
      >
        <div class="repost_tag_wrap hidden-xs-only">
          <span>热门标签：</span>
          <Tag
            v-for="(tag, index) in tagList"
            :key="index"
            :checked="tag.isSelect"
            :name="index"
            checkable
            color="blue"
            size="large"
            @on-change="changeSelectTag"
          >{{ tag.txt }}
          </Tag>
        </div>
        <div class="book_list">
          <p
            class="hidden-xs-only"
            style="width: 60%; margin: 0 auto"
          >
            共<span style="color: #2091d3; padding: 0 6px">{{
              this.bookList.length
            }}</span>个行业报告
          </p>
          <Tabs
            :value="activeIndex + ''"
            class="tabs_wrap"
            draggable
            style=" margin: 0 auto"
          >
            <TabPane
              class="tabs_item"
              label="最新"
              name="0"
            >
              <div class="book_content">
                <div
                  v-for="(item, index) in bookList[0]"
                  :key="index"
                  class="book_item"
                >
                  <div class="book_left">
                    <img
                      :src="'http://www.mtx.cn' + item.front_path"
                      alt=""
                    />
                  </div>
                  <div
                    class="book_right"
                    @click="reportNavigate(item.report_id)"
                  >
                    <span class="hvr-grow">{{ item.report_name }}</span>
                  </div>
                </div>
              </div>
            </TabPane>
            <TabPane
              class="tabs_item"
              label="5G通信"
              name="1"
            >
              <div class="book_content">
                <div
                  v-for="(item, index) in bookList[2]"
                  :key="index"
                  class="book_item"
                >
                  <div class="book_left">
                    <img
                      :src="'http://www.mtx.cn' + item.front_path"
                      alt=""
                    />
                  </div>
                  <div
                    class="book_right"
                    @click="reportNavigate(item.report_id)"
                  >
                    <span class="hvr-grow">{{ item.report_name }}</span>
                  </div>
                </div>
              </div>
            </TabPane>
            <TabPane
              class="tabs_item"
              label="智慧城市"
              name="2"
            >
              <div class="book_content">
                <div
                  v-for="(item, index) in bookList[3]"
                  :key="index"
                  class="book_item"
                >
                  <div class="book_left">
                    <img
                      :src="'http://www.mtx.cn' + item.front_path"
                      alt=""
                    />
                  </div>
                  <div
                    class="book_right"
                    @click="reportNavigate(item.report_id)"
                  >
                    <span class="hvr-grow">{{ item.report_name }}</span>
                  </div>
                </div>
              </div>
            </TabPane>
            <TabPane
              class="tabs_item"
              label="智能充电桩"
              name="3"
            >
              <div class="book_content">
                <div
                  v-for="(item, index) in bookList[3]"
                  :key="index"
                  class="book_item"
                >
                  <div class="book_left">
                    <img
                      :src="'http://www.mtx.cn' + item.front_path"
                      alt=""
                    />
                  </div>
                  <div
                    class="book_right"
                    @click="reportNavigate(item.report_id)"
                  >
                    <span class="hvr-grow">{{ item.report_name }}</span>
                  </div>
                </div>
              </div>
            </TabPane>
            <TabPane
              class="tabs_item"
              label="消费品"
              name="4"
            >
              <div class="book_content">
                <div
                  v-for="(item, index) in bookList[4]"
                  :key="index"
                  class="book_item"
                >
                  <div class="book_left">
                    <img
                      :src="'http://www.mtx.cn' + item.front_path"
                      alt=""
                    />
                  </div>
                  <div
                    class="book_right"
                    @click="reportNavigate(item.report_id)"
                  >
                    <span class="hvr-grow">{{ item.report_name }}</span>
                  </div>
                </div>
              </div>
            </TabPane>
            <TabPane
              class="tabs_item"
              label="旅游体育"
              name="5"
            >
              <div class="book_content">
                <div
                  v-for="(item, index) in bookList[5]"
                  :key="index"
                  class="book_item"
                >
                  <div class="book_left">
                    <img
                      :src="'http://www.mtx.cn' + item.front_path"
                      alt=""
                    />
                  </div>
                  <div
                    class="book_right"
                    @click="reportNavigate(item.report_id)"
                  >
                    <span class="hvr-grow">{{ item.report_name }}</span>
                  </div>
                </div>
              </div>
            </TabPane>
            <TabPane
              class="tabs_item"
              label="产业地产"
              name="6"
            >
              <div class="book_content">
                <div
                  v-for="(item, index) in bookList[6]"
                  :key="index"
                  class="book_item"
                >
                  <div class="book_left">
                    <img
                      :src="'http://www.mtx.cn' + item.front_path"
                      alt=""
                    />
                  </div>
                  <div
                    class="book_right"
                    @click="reportNavigate(item.report_id)"
                  >
                    <span class="hvr-grow">{{ item.report_name }}</span>
                  </div>
                </div>
              </div>
            </TabPane>
            <TabPane
              class="tabs_item"
              label="新材料"
              name="7"
            >
              <div class="book_content">
                <div
                  v-for="(item, index) in bookList[7]"
                  :key="index"
                  class="book_item"
                >
                  <div class="book_left">
                    <img
                      :src="'http://www.mtx.cn' + item.front_path"
                      alt=""
                    />
                  </div>
                  <div
                    class="book_right"
                    @click="reportNavigate(item.report_id)"
                  >
                    <span class="hvr-grow">{{ item.report_name }}</span>
                  </div>
                </div>
              </div>
            </TabPane>
            <TabPane
              class="tabs_item"
              label="环球新工业"
              name="8"
            >
              <div class="book_content">
                <div
                  v-for="(item, index) in bookList[8]"
                  :key="index"
                  class="book_item"
                >
                  <div class="book_left">
                    <img
                      :src="'http://www.mtx.cn' + item.front_path"
                      alt=""
                    />
                  </div>
                  <div
                    class="book_right"
                    @click="reportNavigate(item.report_id)"
                  >
                    <span class="hvr-grow">{{ item.report_name }}</span>
                  </div>
                </div>
              </div>
            </TabPane>
          </Tabs>
        </div>
      </div>

      <div
        v-show="optionActive === 1"
        class="report_avtive_wrap"
      >
        <!-- <div class="repost_tag_wrap hidden-xs-only">
          <span>热门标签：</span>
          <Tag
            color="blue"
            checkable
            :checked="tag.isSelect"
            size="large"
            v-for="(tag, index) in tagList2"
            :key="index"
            :name="index"
            @on-change="changeSelectTag2"
            >{{ tag.txt }}</Tag
          >
        </div> -->
        <div class="book_list">
          <div class="new_title">
            <div style="font-size: 20px; text-align: center">
              <span>— 年报 —</span>
            </div>
            <div style="font-size: 16px; text-align: center">
              <span>ANNUAL REPORT</span>
            </div>
          </div>
          <Tabs
            :value="activeIndex2 + ''"
            class="tabs_wrap"
            draggable
            style=" margin: 0 auto"
            @on-click="tongBuTags"
          >
            <TabPane
              v-for="(cardItem, cardIndex) in cardListObj.industry_list"
              :key="cardIndex"
              :label="cardItem.industry_name"
              :name="cardIndex + ''"
              class="tabs_item"
            >
            </TabPane>
          </Tabs>
          <div
            ref="listScroll"
            class="book_list_scroll"
          >
            <el-row class="card_list">
              <el-col
                v-for="(item, index) in cardListObj.report_group_list[
                activeIndex2
              ]"
                :key="index"
                class="card_item"
              >
                <div
                  class="big_box"
                  @click="reportNavigate(item.report_id)"
                >
                  <div class="item_left">
                    <img
                      :src="'http://www.mtx.cn' + item.front_path"
                      alt=""
                    />
                  </div>
                  <div class="item_right">
                    <h1>{{ item.report_name }}</h1>
                  </div>
                </div>
              </el-col>
            </el-row>
            <div class="list_scroll_btn">
              <el-button
                class="scroll_btn"
                @click="showMoreForReport"
              >查看更多</el-button>
            </div>
          </div>
        </div>
        <!-- ---------------------------------------------------------------------分层辨认... -->
        <div class="book_list">
          <div class="new_title">
            <div style="font-size: 20px; text-align: center">
              <span>— 观察 —</span>
            </div>
            <div style="font-size: 16px; margin-bottom: 15px; text-align: center">
              <span>RESEARCH REPORT</span>
            </div>
          </div>
          <Tabs
            :value="activeIndex3 + ''"
            class="tabs_wrap"
            draggable
            style=" margin: 0 auto"
            @on-click="tongBuTags2"
          >
            <TabPane
              v-for="(cardItem, cardIndex) in cardListObj2.industry_list"
              :key="cardIndex"
              :label="cardItem.industry_name"
              :name="cardIndex + ''"
              class="tabs_item"
            >
            </TabPane>
          </Tabs>
          <div
            ref="listScroll2"
            class="book_list_scroll"
          >
            <el-row class="card_list">
              <el-col
                v-for="(item, index) in cardListObj2.report_group_list[
                activeIndex3
              ]"
                :key="index"
                class="card_item"
              >
                <div
                  class="big_box"
                  @click="reportNavigate(item.report_id)"
                >
                  <div class="item_left">
                    <img
                      :src="'http://www.mtx.cn' + item.front_path"
                      alt=""
                    />
                  </div>
                  <div class="item_right">
                    <h1>{{ item.report_name }}</h1>
                  </div>
                </div>
              </el-col>
            </el-row>
            <div class="list_scroll_btn">
              <el-button
                class="scroll_btn"
                @click="showMoreForReport"
              >查看更多</el-button>
            </div>
          </div>
        </div>
        <!-- ---------------------------------------------------------------------分层辨认... -->
        <div class="book_list">
          <div class="new_title">
            <div style="font-size: 20px; margin-top: 20px; text-align: center">
              <span>— 研究 —</span>
            </div>
            <div style="font-size: 16px; margin-bottom: 15px; text-align: center">
              <span>RESEARCH REPORT</span>
            </div>
          </div>
          <Tabs
            :value="activeIndex4 + ''"
            class="tabs_wrap"
            draggable
            style=" margin: 0 auto"
            @on-click="tongBuTags3"
          >
            <TabPane
              v-for="(cardItem, cardIndex) in cardListObj3.industry_list"
              :key="cardIndex"
              :label="cardItem.industry_name"
              :name="cardIndex + ''"
              class="tabs_item"
            >
            </TabPane>
          </Tabs>
          <div
            ref="listScroll3"
            class="book_list_scroll"
          >
            <el-row class="card_list">
              <el-col
                v-for="(item, index) in cardListObj3.report_group_list[
                activeIndex4
              ]"
                :key="index"
                class="card_item"
              >
                <div
                  class="big_box"
                  @click="reportNavigate(item.report_id)"
                >
                  <div class="item_left">
                    <img
                      :src="'http://www.mtx.cn' + item.front_path"
                      alt=""
                    />
                  </div>
                  <div class="item_right">
                    <h1>{{ item.report_name }}</h1>
                  </div>
                </div>
              </el-col>
            </el-row>
            <div class="list_scroll_btn">
              <el-button
                class="scroll_btn"
                @click="showMoreForReport"
              >查看更多</el-button>
            </div>
          </div>
        </div>
        <!-- ---------------------------------------------------------------------分层辨认... -->
        <div class="book_list">
          <div class="new_title">
            <div style="font-size: 20px; margin-top: 20px; text-align: center">
              <span>— 数据 —</span>
            </div>
            <div style="font-size: 16px;text-align: center">
              <span>DATA</span>
            </div>
          </div>
          <Tabs
            :value="activeIndex5 + ''"
            class="tabs_wrap"
            draggable
            style=" margin: 0 auto"
            @on-click="tongBuTags4"
          >
            <TabPane
              v-for="(cardItem, cardIndex) in cardListObj4.industry_list"
              :key="cardIndex"
              :label="cardItem.industry_name"
              :name="cardIndex + ''"
              class="tabs_item"
            >
            </TabPane>
          </Tabs>
          <div
            ref="listScroll4"
            class="book_list_scroll"
          >
            <el-row class="card_list">
              <el-col
                v-for="(item, index) in cardListObj4.report_group_list[
                activeIndex5
              ]"
                :key="index"
                class="card_item"
              >
                <div
                  class="big_box"
                  @click="reportNavigate(item.report_id)"
                >
                  <div class="item_left">
                    <img
                      :src="'http://www.mtx.cn' + item.front_path"
                      alt=""
                    />
                  </div>
                  <div class="item_right">
                    <h1>{{ item.report_name }}</h1>
                  </div>
                </div>
              </el-col>
            </el-row>
            <div class="list_scroll_btn">
              <el-button
                class="scroll_btn"
                @click="showMoreForReport"
              >查看更多</el-button>
            </div>
          </div>
        </div>
        <div class="new_title">
          <div style="font-size: 20px; margin-top: 20px; text-align: center">
            <span>— 专栏 —</span>
          </div>
          <div style="font-size: 16px; margin-bottom: 15px; text-align: center">
            <span>INDUSTRY COLUMN</span>
          </div>
        </div>
        <el-row
          class="zhuan_column"
          type="flex"
        >
          <el-col
            v-for="(item, index) in columnList"
            :key="index"
            :span="4"
            :xs="12"
            class="zhuan_item"
          >
            <el-card :body-style="{ padding: '0px' }">
              <img
                :src="'http://www.mtx.cn/' + item.front_path"
                class="image"
              />
              <div class="zhuan_content">
                <h1>{{ item.column_name }}</h1>
                <p class="details">
                  {{
                    '已更' +
                    item.episode +
                    '期|' +
                    item.sub_count +
                    '人订阅|' +
                    item.update_time
                  }}
                </p>
                <p class="desc">{{ item.column_description }}</p>
                <el-button class="btn">免费订阅+</el-button>
              </div>
            </el-card>
          </el-col>
        </el-row>
        <div
          class="list_scroll_btn"
          style="text-align: center; margin-top: 30px"
        >
          <el-button
            class="scroll_btn hidden-xs-only"
            plain
            type="warning"
            @click="showColumn"
          >查看更多</el-button>
          <el-button
            class="scroll_btn2 hidden-sm-and-up"
            @click="showColumn"
          >查看更多</el-button>

        </div>
        <div class="new_title">
          <div style="font-size: 20px; margin-top: 20px; text-align: center">
            <span>— 视频 —</span>
          </div>
          <div style="font-size: 16px; margin-bottom: 15px; text-align: center">
            <span>VIDEO</span>
          </div>
        </div>
        <el-row
          class="video_column"
          type="flex"
        >
          <el-col
            v-for="(item, index) in videoList"
            :key="index"
            :span="4"
            :xs="12"
            class="video_item"
          >
            <el-card
              :body-style="{ padding: '0px' }"
              @click.native="videoNavigate(item.video_id)"
            >
              <img
                :src="'http://www.mtx.cn/' + item.front_path"
                class="image"
              />
              <div class="video_content">
                <h1>{{ item.video_name }}</h1>
              </div>
            </el-card>
          </el-col>
        </el-row>
        <div
          class="list_scroll_btn"
          style="text-align: center; margin-top: 30px"
        >
          <el-button
            class="scroll_btn hidden-xs-only"
            plain
            type="warning"
            @click="showVideo"
          >查看所有视频</el-button>
          <el-button
            class="scroll_btn2 hidden-sm-and-up"
            plain
            type="warning"
            @click="showVideo"
          >查看所有视频
          </el-button>
        </div>
      </div>
      <!-- 完毕-------------------------------------------- -->
      <div
        v-show="optionActive === 2"
        class="report_avtive_wrap"
      >
        <div class="book_list book_list_speial media_report_wrap">
          <div class="media_report_inner">
            <div class="media_report_header">
              <p class="media_report_stat">
                共<span class="media_report_stat_num">{{ mediaNewsTotal }}</span>篇媒体报道
              </p>
            </div>
            <div class="media_report_grid">
              <article
                v-for="(item, index) in paginatedMediaNews"
                :key="'m-' + mediaCurrentPage + '-' + index"
                class="media_report_card"
                :style="{ animationDelay: index * 0.055 + 's' }"
                @click="handleNewsDetails(item)"
              >
                <div class="media_report_thumb">
                  <img
                    :src="item.img"
                    :alt="item.title"
                  >
                  <span
                    v-if="isWechatNews(item)"
                    class="media_source_badge"
                  >转载</span>
                </div>
                <div class="media_report_body">
                  <h2 class="media_report_title">{{ item.title }}</h2>
                  <p class="media_content_preview">{{ item.intro }}</p>
                  <div class="media_card_footer">
                    <time class="media_meta">{{ item.createTime }}</time>
                    <span class="media_read_more">
                      {{ isExternalNewsUrl(item.url) ? '查看原文' : '阅读全文' }}
                      <i class="el-icon-arrow-right"></i>
                    </span>
                  </div>
                </div>
              </article>
            </div>
            <el-pagination
              v-if="mediaNewsTotal > mediaPageSize"
              class="media_pagination"
              background
              :layout="isMobile ? 'prev, pager, next' : 'total, prev, pager, next'"
              :pager-count="isMobile ? 5 : 7"
              :current-page="mediaCurrentPage"
              :page-size="mediaPageSize"
              :total="mediaNewsTotal"
              @current-change="handleMediaPageChange"
            />
          </div>
        </div>
      </div>
    </div>
    <div class="report_page_foot">
      <CallMe/>
      <MobileCallme/>
    </div>
  </div>
</template>

<script>
import BScroll from '@better-scroll/core'
import Pullup from '@better-scroll/pull-up'
import MouseWheel from '@better-scroll/mouse-wheel'

BScroll.use(Pullup)
BScroll.use(MouseWheel)
import { mediaList, isExternalNewsUrl, isWechatNews, openNewsLink } from '@/utils/mediaList'
import CallMe from '@/components/callme/index'
import MobileCallme from '@/components/callme/MobileCallme.vue'

export default {
  components: {
    CallMe,
    MobileCallme,
  },
  data () {
    return {
      optionsList: [
        {
          icon: require('@/assets/img/63.png'),
          txt: '行业报告',
        },
        {
          icon: require('@/assets/img/64.png'),
          txt: '精选文章',
        },
        {
          icon: require('@/assets/img/65.png'),
          txt: '媒体报道',
        },
      ],
      optionActive: 0,
      tagList: [
        {
          isSelect: true,
          txt: '最新',
        },
        {
          isSelect: false,
          txt: '5G通信',
        },
        {
          isSelect: false,
          txt: '智慧城市',
        },
        {
          isSelect: false,
          txt: '智能充电桩',
        },
        {
          isSelect: false,
          txt: '消费品',
        },
        {
          isSelect: false,
          txt: '旅游体育',
        },
        {
          isSelect: false,
          txt: '产业地产',
        },
        {
          isSelect: false,
          txt: '新材料',
        },
        {
          isSelect: false,
          txt: '环球新工业',
        },
      ],
      tagList2: [
        {
          isSelect: true,
          txt: '全部',
        },
        {
          isSelect: false,
          txt: '招商月报',
        },
        {
          isSelect: false,
          txt: '热点解读',
        },
      ],
      bookList: [
        {
          icon: require('@/assets/img/Jey8DRSC2T1635155480914.jpg'),
          txt: '2021年生物医药专业服务体系建设专业报告',
        },
        {
          icon: require('@/assets/img/EQWQ6CirG61634107019389.jpg'),
          txt: '《2021年中国特医食品产业发展专题报告》',
        },
        {
          icon: require('@/assets/img/DPWmMfikTc1634106711716.jpg'),
          txt: '《2021年中国第三代半导体产业发展专题报告》',
        },
        {
          icon: require('@/assets/img/JRDhGAnjC81629106363407.jpg'),
          txt: '《2021年医药外包服务产业图谱专题报告》',
        },
        {
          icon: require('@/assets/img/NPFcadZW6a1634106943049.jpg'),
          txt: '《2021年中国汽车产业发展专题报告》',
        },
        {
          icon: require('@/assets/img/wdkYBTNfFW1634106816405.jpg'),
          txt: '《2021年8月产业大脑数字专刊》',
        },
        {
          icon: require('@/assets/img/YTSr8WDtaM1629106376130.jpg'),
          txt: '《2021年中医药产业发展专题报告》',
        },
        {
          icon: require('@/assets/img/zyZpHiYFPM1629106347965.jpg'),
          txt: '《2021年6月产业大脑数字专刊》',
        },
      ],
      activeIndex: 0,
      cardListObj: {
        industry_list: [],
        report_group_list: [],
      },
      cardListObj2: {
        industry_list: [],
        report_group_list: [],
      },
      cardListObj3: {
        industry_list: [],
        report_group_list: [],
      },
      cardListObj4: {
        industry_list: [],
        report_group_list: [],
      },
      mediaCurrentPage: 1,
      mediaPageSize: 5,
      isMobile: false,
      scroll: null,
      scroll2: null,
      scroll3: null,
      scroll4: null,
      timer: null,
      pageNo: 1,
      total1: 0,
      total2: 0,
      activeIndex2: 0,
      activeIndex3: 0,
      activeIndex4: 0,
      activeIndex5: 0,
      columnList: [],
      videoList: [],
    }
  },
  created () {
    this.optionActive =
      this.$route.path.substr(this.$route.path.length - 1) * 1 - 1
  },
  computed: {
    mediaNewsList () {
      return mediaList
    },
    mediaNewsTotal () {
      return this.mediaNewsList.length
    },
    paginatedMediaNews () {
      const start =
        (this.mediaCurrentPage - 1) * this.mediaPageSize
      return this.mediaNewsList.slice(
        start,
        start + this.mediaPageSize
      )
    },
  },
  mounted () {
    this.checkMobile()
    window.addEventListener('resize', this.checkMobile)
    if (!this.isMobile) {
      this.initHorizontalScroll()
    }

    this.getBookList()
    this.getCardListData()
    this.getCardListData2()
    this.getCardListData3()
    this.getCardListData4()
    this.getColumnList()
    this.getVideoList()
    // this.getReportData()
    // this.scroll.on('pullingUp', () => {
    //   if (this.optionActive === 1) {
    //     console.log('请求数据...')
    //     switch (this.activeIndex) {
    //       case 0:
    //         this.getCardListData()
    //         break
    //       case 1:
    //         this.getCardListData('招商月报')
    //         break
    //       default:
    //         this.getCardListData('热点解读')
    //         break
    //     }
    //   } else if (this.optionActive === 2) {
    //     // this.getReportData()
    //   } else {
    //     // this.scroll.finishPullUp()
    //   }
    // })
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.checkMobile)
    this.destroyHorizontalScroll()
  },
  methods: {
    checkMobile () {
      this.isMobile = window.innerWidth <= 768
    },
    initHorizontalScroll () {
      const scrollOptions = {
        scrollX: true,
        eventPassthrough: 'vertical',
        mouseWheel: {
          speed: 20,
          invert: false,
          easeTime: 300,
        },
      }
      if (this.$refs.listScroll) {
        this.scroll = new BScroll(this.$refs.listScroll, scrollOptions)
      }
      if (this.$refs.listScroll2) {
        this.scroll2 = new BScroll(this.$refs.listScroll2, scrollOptions)
      }
      if (this.$refs.listScroll3) {
        this.scroll3 = new BScroll(this.$refs.listScroll3, scrollOptions)
      }
      if (this.$refs.listScroll4) {
        this.scroll4 = new BScroll(this.$refs.listScroll4, scrollOptions)
      }
    },
    destroyHorizontalScroll () {
      ;[this.scroll, this.scroll2, this.scroll3, this.scroll4].forEach((s) => {
        if (s) s.destroy()
      })
      this.scroll = null
      this.scroll2 = null
      this.scroll3 = null
      this.scroll4 = null
    },
    refreshHorizontalScroll () {
      if (this.isMobile) return
      this.$nextTick(() => {
        this.scroll && this.scroll.refresh()
        this.scroll2 && this.scroll2.refresh()
        this.scroll3 && this.scroll3.refresh()
        this.scroll4 && this.scroll4.refresh()
      })
    },
    changeOptionIndex (index) {
      this.optionActive = index
      const targetPath = `/fournav/${index + 1}`
      if (this.$route.path !== targetPath) {
        this.$router.push(targetPath).catch(() => {})
      }
      if (index === 1) {
        this.refreshHorizontalScroll()
      }
      if (index === 2) {
        this.mediaCurrentPage = 1
      }
    },
    changeSelectTag (checked, name) {
      this.activeIndex = name
      this.tagList.map((v, i) => {
        if (name === i) {
          v.isSelect = checked
        } else {
          v.isSelect = false
        }
      })
    },
    changeSelectTag2 (checked, name) {
      this.activeIndex2 = name
      this.tagList2.map((v, i) => {
        if (name === i) {
          v.isSelect = checked
        } else {
          v.isSelect = false
        }
      })
    },
    tongBuTags (name) {
      this.activeIndex2 = name * 1
      if (this.scroll) this.scroll.scrollTo(0, 0)
    },
    tongBuTags2 (name) {
      this.activeIndex3 = name * 1
      if (this.scroll2) this.scroll2.scrollTo(0, 0)
    },
    tongBuTags3 (name) {
      this.activeIndex4 = name * 1
      if (this.scroll3) this.scroll3.scrollTo(0, 0)
    },
    tongBuTags4 (name) {
      this.activeIndex5 = name * 1
      if (this.scroll4) this.scroll4.scrollTo(0, 0)
    },
    handleNewsDetails (item) {
      openNewsLink(item, this.$router)
    },
    isExternalNewsUrl,
    isWechatNews,
    handleMediaPageChange (page) {
      this.mediaCurrentPage = page
      if (this.isMobile) {
        window.scrollTo({ top: 0, behavior: 'smooth' })
      }
    },
    async getCardListData () {
      const res = await this.axios.get(
        'https://api.mtx.cn/report?command=front_yj'
      )
      this.cardListObj = res.data.data
    },
    async getBookList () {
      const res = await this.axios.get(
        'https://api.mtx.cn/report?command=front_nb'
      )
      this.bookList = res.data.data.report_group_list
    },
    async getCardListData2 () {
      const res = await this.axios.get(
        'https://api.mtx.cn/report?command=front_gc'
      )
      this.cardListObj2 = res.data.data
    },
    async getCardListData3 () {
      const res = await this.axios.get(
        'https://api.mtx.cn/report?command=front_nb'
      )
      this.cardListObj3 = res.data.data
    },
    async getCardListData4 () {
      const res = await this.axios.get(
        'https://api.mtx.cn/report?command=front_yj'
      )
      this.cardListObj4 = res.data.data
    },
    async getColumnList () {
      const res = await this.axios.get(
        'https://api.mtx.cn/column?command=front_all'
      )
      this.columnList = res.data.data.column_list
    },
    async getVideoList () {
      const res = await this.axios.get(
        'https://api.mtx.cn/video?command=front_list'
      )
      this.videoList = res.data.data.video_list
    },
    reportNavigate (id) {
      window.open(`http://www.mtx.cn/#/report?id=${id}`)
    },
    videoNavigate (id) {
      window.open(`http://www.mtx.cn/#/video?id=${id}`)
    },
    showMoreForReport () {
      window.open('http://www.mtx.cn/#/search?type=0')
    },
    showColumn () {
      window.open('http://www.mtx.cn/#/search?type=2')
    },
    showVideo () {
      window.open('http://www.mtx.cn/#/videolist')
    }
    //智能工业装备发送请求 媒体报道
    // async getReportData() {
    //   const res = await this.axios.get(
    //     `/news/officialNews/listPage?keyword=&newsColumn=3&tags=&pageNo=${this.pageNoMedia}&pageSize=10`
    //   )
    //   this.pageNoMedia += 1
    //   this.mediaList = [...this.mediaList, ...res.data.result.records]
    //   this.total2 = res.data.result.total
    //   this.$nextTick(() => {
    //     this.scroll.finishPullUp()
    //     this.scroll.refresh()
    //   })
    // },
  },
  watch: {
    $route () {
      this.optionActive =
        this.$route.path.substr(this.$route.path.length - 1) * 1 - 1
    },
  },
}
</script>

<style lang="scss">
.report_wrap {
  // height: 100vh;
  // overflow: hidden;

  /* 移动端底部 CallMe 区域：抬高层级，避免被上方溢出内容盖住 */
  .report_page_foot {
    position: relative;
    z-index: 2;
    flex-shrink: 0;
    isolation: isolate;
  }

  .repost_mobile_shiying {
    position: relative;
    z-index: 1;

    @media screen and (max-width: 768px) {
      padding-bottom: 24px;
      margin-bottom: 0;
    }

    .report_img {
      width: 100%;
      height: 600px;

      @media screen and (max-width: 768px) {
        height: 36vw;
        min-height: 128px;
        max-height: 180px;
      }

      background: url("../../assets/img/newbg.22e89fc.jpg") 0 0 no-repeat;
      background-size: 100% 100%;
      color: #fff;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      position: relative;

      .img_tit {
        font-size: 60px;
        font-weight: bold;

        @media screen and (max-width: 768px) {
          font-size: 1.2rem;
        }
      }
    }

    .report_options {
      width: 100%;
      height: 120px;
      box-shadow: 0px 5px 5px rgba($color: #000000, $alpha: 0.1);

      @media screen and (max-width: 768px) {
        position: sticky;
        top: 64PX;
        z-index: 20;
        height: auto;
        padding: 10px 12px;
        background: #fff;
        box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);
      }

      .option {
        width: 70%;
        margin: 0 auto;
        align-items: center;

        @media screen and (max-width: 768px) {
          width: 100%;
        }

        .option_item {
          display: flex;
          justify-content: center;
          flex-direction: column;
          align-items: center;
          cursor: pointer;

          @media screen and (max-width: 768px) {
            padding: 8px 4px;
            border-radius: 10px;
            transition: background 0.2s ease;
          }

          &.option_item--active {
            @media screen and (max-width: 768px) {
              background: rgba(32, 145, 211, 0.08);
            }
          }

          .item_top {
            width: 15%;
            margin-top: 10px;

            @media screen and (max-width: 768px) {
              width: 36px;
              margin-top: 0;
            }

            img {
              width: 100%;
            }
          }

          .item_bottom {
            margin-left: 5px;
            font-weight: bold;
            font-size: 20px;

            @media screen and (max-width: 768px) {
              margin-left: 0;
              margin-top: 6px;
              font-size: 13px;
              text-align: center;
              line-height: 1.3;
            }
          }

          .active {
            color: #2091d3;
          }
        }
      }
    }

    .repost_tag_wrap {
      width: 60%;
      height: 100px;
      background: #f4f9fc;
      margin: 50px auto;
      display: flex;
      align-items: center;
      padding: 0 30px;

      span {
        color: #8a989c;
        font-size: 18px;
      }
    }

    .book_list {
      /* 移动端勿固定高度：原先 470px 导致列表溢出叠在底部 MobileCallme 之上 */
      @media screen and (max-width: 768px) {
        height: auto;
        min-height: 0;
        padding-bottom: 28px;
        box-sizing: border-box;
      }

      .new_title {
        @media screen and (min-width: 768px) {
          margin-top: 30px;
        }

        &:nth-child(n + 2) {
          margin-top: 60px;
        }

        @media screen and (max-width: 768px) {
          padding-top: 15px;
        }
      }

      @media screen and (max-width: 768px) {
        width: 100%;
        padding: 0 12px 20px;
        background: #f4f9fc;
        box-sizing: border-box;

        &.media_report_wrap {
          padding: 12px 12px 20px;
          background: #f5f7fa;
        }
      }

      .book_list_scroll {
        width: 1500px;
        margin: 0 auto;
        overflow: hidden;

        @media screen and (max-width: 768px) {
          width: 100%;
          overflow: visible;
          height: auto !important;
        }

        .card_list {
          width: 3000px;

          @media screen and (max-width: 768px) {
            width: 100% !important;
            display: grid;
            grid-template-columns: repeat(2, 1fr);
            gap: 12px;
            margin-top: 16px;
          }

          .card_item {
            @media screen and (max-width: 768px) {
              width: 100% !important;
              height: auto !important;
              float: none !important;
            }

            float: left;
            width: 300px;
            text-align: center;

            &:hover {
              transform: scale(1);
              box-shadow: none;
            }

            .big_box {
              display: flex;
              flex-direction: column;
              justify-content: center;
              align-items: center;

              @media screen and (max-width: 768px) {
                height: 100%;
                background: #fff;
                border-radius: 8px;
                overflow: hidden;
                box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
              }

              .item_left {
                width: 300px;
                text-align: center;
                user-select: none;

                @media screen and (max-width: 768px) {
                  width: 100%;
                  height: auto;
                }

                img {
                  transition: all 0.6s;
                  width: 80%;
                  min-height: 300px;
                  margin-left: 20px;
                  border: solid 1px rgb(235, 235, 235);

                  &:hover {
                    box-shadow: 0 0 20px rgba($color: #000000, $alpha: 0.1);
                  }

                  @media screen and (max-width: 768px) {
                    width: 100%;
                    min-height: 0;
                    max-height: 150px;
                    margin-left: 0;
                    object-fit: cover;
                    border: none;
                    border-bottom: 1px solid #eee;
                  }
                }
              }

              .item_right {
                padding: 10px 20px !important;

                @media screen and (max-width: 768px) {
                  padding: 10px 8px 12px !important;
                  width: 100%;
                  box-sizing: border-box;
                }

                h1 {
                  font-size: 0.1rem !important;
                  font-weight: 400;
                  text-align: center;
                  white-space: normal;

                  @media screen and (max-width: 768px) {
                    font-size: 13px !important;
                    line-height: 1.45;
                    display: -webkit-box;
                    -webkit-line-clamp: 3;
                    -webkit-box-orient: vertical;
                    overflow: hidden;
                  }
                }
              }
            }
          }
        }

        .list_scroll_btn {
          text-align: center;

          .scroll_btn {
            background: #ffa400;
            color: #fff;
            font-size: 14px;
            border-radius: 15px;
            border-color: #ffa400;

            @media screen and (max-width: 768px) {
              width: min(280px, 90%);
              height: 40px;
              margin-top: 24px;
              padding: 0 20px;
              background-color: #ffa400 !important;
              border-color: #ffa400 !important;
              color: #fff !important;
              font-size: 14px !important;
              line-height: 1;
              border-radius: 20px;

              span {
                color: #fff !important;
              }
            }
          }
        }
      }

      .book_content {
        margin-top: 20px;
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;

        @media screen and (max-width: 768px) {
          width: 100%;
        }

        .book_item {
          width: 45%;
          display: flex;

          @media screen and (max-width: 768px) {
            width: 100%;
            background: #fff;
            margin: 0 auto 12px;
            padding: 12px;
            border-radius: 10px;
            box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
            box-sizing: border-box;
            align-items: center;
          }

          &:nth-child(n + 3) {
            margin-top: 20px;
          }

          .book_left {
            width: 50%;
            margin-right: 40px;

            @media screen and (max-width: 768px) {
              width: 88px;
              flex-shrink: 0;
              margin-right: 12px;
            }

            img {
              width: 100%;
            }
          }

          .book_right {
            font-weight: bold;
            font-size: 20px;

            span {
              cursor: pointer;
            }

            @media screen and (max-width: 768px) {
              flex: 1;
              min-width: 0;
              font-size: 14px;
              font-weight: 600;
              color: #1c212d;
              line-height: 1.45;
            }
          }
        }
      }

      .tabs_wrap {
        width: 60%;

        @media screen and (max-width: 768px) {
          width: 100%;
        }

        padding-top: 1rem;
      }
    }
  }

  .ivu-tabs-tab {
    font-size: 1rem !important;
    height: 2rem !important;
  }

}

.zhuan_column {
  width: 100%;
  margin: 0 auto;
  flex-wrap: wrap;
  justify-content: space-evenly;

  img {
    width: 100%;
  }

  .zhuan_item {
    @media screen and (max-width: 768px) {
      &:nth-child(n + 3) {
        margin-top: 10px;
      }
    }

    .zhuan_content {
      padding: 14px;

      @media screen and (max-width: 768px) {
        pad: 10px;
      }

      h1 {
        min-height: 80px;
        color: #ffa400;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        font-size: 1.1rem;

        @media screen and (max-width: 768px) {
          min-height: 55px;
        }
      }

      .btn {
        background: #ffa400;
        float: right;
        color: #fff;
        margin-top: 20px;
        width: 80px;
        height: 35px;
        border-radius: 20px;

        @media screen and (max-width: 768px) {
          font-size: 12px;
        }
      }

      .details {
        color: #999;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 1;
        -webkit-box-orient: vertical;

        @media screen and (max-width: 768px) {
          font-size: 13px;
        }
      }

      .desc {
        color: #666;
        min-height: 60px;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 3;
        -webkit-box-orient: vertical;
        margin: 10px 0;

        @media screen and (max-width: 768px) {
          font-size: 13px;
        }
      }
    }
  }
}

.video_column {
  width: 100%;
  margin: 0 auto;
  flex-wrap: wrap;
  justify-content: space-evenly;

  .video_item {
    .video_content {
      cursor: pointer;
      padding: 14px;

      h1 {
        color: #666;
        font-size: 0.9rem;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 3;
        -webkit-box-orient: vertical;

        @media screen and (max-width: 768px) {
          min-height: 65px;
        }
      }
    }

    img {
      width: 100%;
      min-height: 180px;
      cursor: pointer;

      @media screen and (max-width: 768px) {
        min-height: 106px;
      }
    }
  }
}

.book_list_speial {
  padding-top: 16px;
  width: 70%;
  margin: 0 auto;

  &.media_report_wrap {
    @media screen and (max-width: 768px) {
      width: 100%;
      padding: 12px 12px 20px;
      margin: 0;
      background: #f5f7fa;
      box-sizing: border-box;
    }
  }

  @media screen and (max-width: 768px) {
    width: 100%;
    padding: 12px 12px 0;
    box-sizing: border-box;
  }

  .media_pagination {
    margin: 24px auto 32px;
    padding-top: 8px;
    text-align: center;

    @media screen and (max-width: 768px) {
      margin: 12px 0 0;
      padding: 16px 10px;
      background: #fff;
      border-radius: 10px;
      border: 1px solid #e8ecef;
      display: flex;
      justify-content: center;
      align-items: center;
      flex-wrap: wrap;
      gap: 6px;

      &.is-background .btn-prev,
      &.is-background .btn-next,
      &.is-background .el-pager li {
        min-width: 42px;
        height: 42px;
        line-height: 42px;
        font-size: 15px;
        font-weight: 500;
        margin: 0 3px;
        border-radius: 8px;
      }

      &.is-background .el-pager li:not(.disabled).active {
        background-color: #2091d3;
        color: #fff;
      }
    }
  }
}

/* 媒体报道：独立布局与动效（不再共用 .card_list） */
@keyframes mediaReportCardIn {
  from {
    opacity: 0;
    transform: translateY(16px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.media_report_wrap {
  padding-bottom: 56px;
  box-sizing: border-box;

  @media screen and (max-width: 768px) {
    padding-bottom: 24px;
  }

  .media_report_inner {
    max-width: 1100px;
    margin: 0 auto;

    @media screen and (max-width: 768px) {
      max-width: none;
      width: 100%;
      margin: 0;
      padding: 0;
    }
  }

  .media_report_header {
    margin-bottom: 16px;

    @media screen and (max-width: 768px) {
      margin-bottom: 12px;
      padding: 0 2px;
      background: transparent;
      border-bottom: none;
    }
  }

  .media_report_stat {
    font-size: 13px;
    color: #8a989c;
    letter-spacing: 0.02em;
    margin: 0;
    text-align: left;

    @media screen and (max-width: 768px) {
      font-size: 12px;
    }
  }

  .media_report_stat_num {
    color: #2091d3;
    font-weight: 600;
    padding: 0 6px;
  }

  .media_report_grid {
    display: flex;
    flex-direction: column;
    gap: 18px;

    @media screen and (max-width: 768px) {
      gap: 12px;
    }
  }

  .media_report_card {
    display: flex;
    flex-direction: row;
    align-items: stretch;
    background: #fff;
    border-radius: 12px;
    border: 1px solid #e6eaee;
    overflow: hidden;
    cursor: pointer;
    box-shadow: 0 2px 10px rgba(32, 48, 64, 0.04);
    animation: mediaReportCardIn 0.48s cubic-bezier(0.22, 1, 0.36, 1) both;
    transition: transform 0.38s cubic-bezier(0.22, 1, 0.36, 1),
      box-shadow 0.38s ease,
      border-color 0.3s ease;

    &:hover {
      transform: translateY(-4px);
      box-shadow: 0 14px 36px rgba(32, 48, 64, 0.12);
      border-color: rgba(32, 145, 211, 0.45);
    }

    &:active {
      transform: translateY(-2px);
      transition-duration: 0.12s;
    }

    @media screen and (max-width: 768px) {
      flex-direction: column;
      align-items: stretch;
      gap: 0;
      padding: 0;
      margin: 0;
      border: 1px solid #e8ecef;
      border-radius: 10px;
      box-shadow: 0 2px 8px rgba(32, 48, 64, 0.05);
      animation: none;
      overflow: hidden;

      &:hover {
        transform: none;
        box-shadow: 0 2px 8px rgba(32, 48, 64, 0.05);
        border-color: #e8ecef;
      }

      &:active {
        background: #fafbfc;
        transform: none;
        border-color: rgba(32, 145, 211, 0.35);
      }
    }
  }

  .media_report_thumb {
    position: relative;
    flex: 0 0 280px;
    max-width: 280px;
    background: #f0f3f6;
    overflow: hidden;

    @media screen and (max-width: 768px) {
      flex: none;
      width: 100%;
      max-width: none;
      height: auto;
      aspect-ratio: 16 / 9;
      border-radius: 0;
    }

    img {
      width: 100%;
      height: 100%;
      min-height: 200px;
      object-fit: cover;
      display: block;
      -webkit-user-drag: none;
      -webkit-backface-visibility: hidden;
      backface-visibility: hidden;
      transition: transform 0.55s cubic-bezier(0.22, 1, 0.36, 1);

      @media screen and (max-width: 768px) {
        min-height: 0;
      }
    }
  }

  .media_source_badge {
    position: absolute;
    left: 10px;
    top: 10px;
    z-index: 1;
    padding: 3px 8px;
    font-size: 12px;
    font-weight: 500;
    line-height: 1.4;
    letter-spacing: 0.04em;
    color: #fff;
    background: rgba(32, 48, 64, 0.78);
    border-radius: 4px;
    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.18);
    pointer-events: none;

    @media screen and (max-width: 768px) {
      left: 8px;
      top: 8px;
      padding: 4px 8px;
      font-size: 11px;
      line-height: 1.3;
      border-radius: 3px;
      background: rgba(32, 48, 64, 0.82);
    }
  }

  .media_report_card:hover .media_report_thumb img {
    transform: scale(1.05);
  }

  .media_report_body {
    flex: 1;
    min-width: 0;
    padding: 22px 26px 20px;
    display: flex;
    flex-direction: column;
    gap: 0;

    @media screen and (max-width: 768px) {
      padding: 12px 14px 14px;
      min-width: 0;
    }
  }

  .media_report_title {
    margin: 0 0 12px;
    font-size: 22px;
    font-weight: 600;
    line-height: 1.4;
    color: #203040;

    @media screen and (max-width: 768px) {
      font-size: 15px;
      margin-bottom: 8px;
      line-height: 1.45;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      overflow: hidden;
    }
  }

  .media_content_preview {
    flex: 1;
    margin: 0;
    font-size: 14px;
    line-height: 1.75;
    word-break: break-word;
    color: #4a5568;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    overflow: hidden;

    @media screen and (max-width: 768px) {
      font-size: 13px;
      line-height: 1.6;
      -webkit-line-clamp: 2;
      color: #666;
    }
  }

  .media_card_footer {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 8px;
    margin-top: 16px;

    @media screen and (max-width: 768px) {
      margin-top: 10px;
      padding-top: 10px;
      border-top: 1px solid #f0f2f5;
    }
  }

  .media_meta {
    display: inline-block;
    flex-shrink: 0;
    padding: 4px 12px;
    font-size: 12px;
    color: #2091d3;
    background: rgba(32, 145, 211, 0.08);
    border-radius: 20px;
    font-style: normal;

    @media screen and (max-width: 768px) {
      padding: 0;
      background: none;
      font-size: 11px;
      color: #999;
    }
  }

  .media_read_more {
    flex-shrink: 0;
    font-size: 13px;
    color: #2091d3;
    display: inline-flex;
    align-items: center;
    gap: 2px;

    i {
      font-size: 12px;
    }

    @media screen and (max-width: 768px) {
      font-size: 12px;
    }
  }

  .media_pagination {
    margin-top: 8px;

    @media screen and (max-width: 768px) {
      margin-top: 12px;
    }

    ::v-deep .el-pager li.active {
      color: #2091d3;
    }

    ::v-deep .btn-prev,
    ::v-deep .btn-next {
      transition: color 0.2s ease, background 0.2s ease;
    }
  }
}

.scroll_btn2 {
  @media screen and (max-width: 768px) {
    width: min(280px, 90%);
    height: 40px;
    margin-top: 24px;
    padding: 0 20px;
    background-color: #ffa400 !important;
    border-color: #ffa400 !important;
    color: #fff !important;
    font-size: 14px !important;
    line-height: 1;
    border-radius: 20px;

    span {
      color: #fff !important;
    }
  }
}

@media screen and (max-width: 768px) {
  .report_wrap {
    .ivu-tabs-nav-scroll {
      overflow-x: auto;
      -webkit-overflow-scrolling: touch;
    }

    .ivu-tabs-nav {
      display: flex;
      flex-wrap: nowrap;
    }

    .ivu-tabs-tab {
      font-size: 13px !important;
      height: auto !important;
      padding: 8px 10px !important;
      white-space: nowrap;
    }

    .new_title {
      div {
        font-size: 16px !important;

        span {
          font-size: inherit !important;
        }

        & + div span {
          font-size: 12px !important;
          letter-spacing: 0.06em;
        }
      }
    }

    .zhuan_column,
    .video_column {
      padding: 0 4px;
    }

    .list_scroll_btn {
      .el-button.scroll_btn,
      .el-button.scroll_btn2 {
        background-color: #ffa400 !important;
        border-color: #ffa400 !important;
        color: #fff !important;

        span {
          color: #fff !important;
        }
      }
    }
  }
}
</style>